import { useEffect, useState } from "react";
import { useAppDispatch } from "@/store";
import usePolling from "./usePolling";
import { setMonitPanel } from "@/store/modules/pubCommun";
import { useParams } from "react-router-dom";
import { TelemetryItem } from "@/facilities/model/user";

export const useLiftRbes = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();
  const [rebTempers, setRebTempers] = useState<TelemetryItem[]>([]);
  const { data } = usePolling({ url: `/api/telemetry/${id}` });

  useEffect(() => {
    setRebTempers(data || []);
    dispatch(setMonitPanel(data || []));
  }, [data, dispatch]);

  return { rebTempers };
};

export default useLiftRbes;
